import { createRandomString } from 'utils/common';
import type { ModulesAndAgendasState } from '../index';
import type { LocalFormItem, LocalFormItemTab } from 'types/agendaForm.ts';
import { findSectionIndex, findTabIndex } from 'utils/section/tabSection.ts';

export interface Payload {
  name: string;
  currentTab: number;
}

export const resetSection = (state: ModulesAndAgendasState, { payload }: { payload: Payload }) => {
  const { name, currentTab } = payload;
  const tabSections = state.tabSections;

  const currentTabIndex = findTabIndex(tabSections, currentTab);
  if (currentTabIndex === -1) throw new Error('Invalid tab index');

  const sectionIndex = findSectionIndex(tabSections[currentTabIndex].sections, name);
  if (sectionIndex === -1) throw new Error('Invalid section index');

  state.tabSections[currentTab].sections[sectionIndex] = {
    ...tabSections[currentTab].sections[sectionIndex],
    gridSizeX: 1,
    gridSizeY: 1,
    items: [
      {
        x: '0',
        y: '0',
        identifier: createRandomString(10),
        isEmpty: true,
        data: null,
      },
    ] satisfies LocalFormItem[],
    formItemTabs: [
      {
        tab: { number: 0, name: tabSections[currentTab].sections[sectionIndex].name ?? null },
        items: [
          {
            x: '0',
            y: '0',
            identifier: createRandomString(10),
            isEmpty: true,
            data: null,
          },
        ],
      },
    ] satisfies LocalFormItemTab[],
  };
};
